import { motion } from "framer-motion";
import { useSettings } from "../../context/SettingsContext";

export function whatsappLink(number, text = "Hello Quantora, I would like to know more about your financial services.") {
  return `https://wa.me/${(number || "917070704697").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;
}

export default function WhatsAppButton() {
  const { settings } = useSettings();
  return (
    <motion.a
      href={whatsappLink(settings?.whatsapp_number)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Quantora on WhatsApp"
      data-testid="whatsapp-float-btn"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_10px_30px_rgba(37,211,102,0.45)]"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-20" />
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#fff" aria-hidden="true">
        <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.25-1.6a12.1 12.1 0 0 0 3.79.6C22.68 28 28 22.64 28 16.03 28 9.42 22.68 3 16.04 3zm0 22.9c-1.2 0-2.37-.2-3.48-.6l-.5-.17-4.9.95.97-4.73-.33-.53a9.86 9.86 0 0 1-1.52-5.25c0-5.47 4.33-9.93 9.76-9.93 5.4 0 9.77 4.46 9.77 9.93 0 5.88-4.38 10.33-9.77 10.33zm5.35-7.38c-.29-.15-1.73-.86-2-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.14-.17.2-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.6-.9-2.19-.24-.57-.48-.5-.66-.5h-.56c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44s1.05 2.83 1.2 3.03c.15.2 2.06 3.15 5 4.42.7.3 1.24.48 1.67.62.7.22 1.34.19 1.84.12.56-.08 1.73-.71 1.98-1.4.24-.68.24-1.27.17-1.39-.07-.12-.27-.2-.56-.34z" />
      </svg>
    </motion.a>
  );
}
